import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { getExperienceListKey } from 'lib/experiences/experienceUtils'
import { type ExperienceListFilters } from 'actions/ExperienceActions'
import { generateTopOfferFilters, generateCategoryFilters, calculateTargetAudience } from 'lib/experiences/generateExperienceFilters'

interface Params {
  currencyCode: string
  offer: App.HotelOffer | App.VillaOffer
  checkIn?: string
  checkOut?: string
  durationDays?: number
  rooms: Array<App.RoomOccupants>
  categories: Array<App.ExperienceItemCategory>
  geoCoords: { latitude?: number, longitude?: number }
  oneClickTransferEnabled?: boolean
}

export function buildPrefetchTopOfferFilters(params: Params): Array<ExperienceListFilters> {
  const { currencyCode, offer, checkIn, checkOut, durationDays, rooms, categories, geoCoords, oneClickTransferEnabled } = params

  const actualCheckIn = checkIn
  const actualCheckOut = checkOut || (checkIn && durationDays ? moment(checkIn).add(durationDays, 'days').format(ISO_DATE_FORMAT) : undefined)

  const from = actualCheckIn ? moment(actualCheckIn).add(-7, 'days').format(ISO_DATE_FORMAT) : undefined
  const to = actualCheckOut ? moment(actualCheckOut).add(7, 'days').format(ISO_DATE_FORMAT) : undefined

  const targetAudience = calculateTargetAudience({ adults: rooms[0].adults, children: rooms[0].children })

  const topOfferFilters = generateTopOfferFilters({
    currencyCode,
    geoCoords: { latitude: offer.property?.latitude, longitude: offer.property?.longitude },
    hotelOffer: { id: offer.id, experiencesCurated: offer.experiencesCurated },
    availability: { from, to },
    hasNoIncludedTransfer: true,
    targetAudience,
  })

  const categoryFilters = generateCategoryFilters({
    categories,
    geoCoords,
    startDate: actualCheckIn || '',
    endDate: actualCheckOut || '',
    currencyCode,
    targetAudience,
    oneClickTransferEnabled,
  })

  return [...topOfferFilters, ...categoryFilters]
}

export default buildPrefetchTopOfferFilters

export function isExperienceListStale(
  experienceLists: App.ExperienceListState,
  filters: ExperienceListFilters,
): boolean {
  const key = getExperienceListKey(filters)
  const existing = experienceLists[key]
  return !existing || (!existing.fetching && !existing.total)
}
